import { render } from "./MainUser.vue?vue&type=template&id=58648e06"
import script from "./MainUser.vue?vue&type=script&lang=js"
export * from "./MainUser.vue?vue&type=script&lang=js"

import "./MainUser.vue?vue&type=style&index=0&id=58648e06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__